export default class WebchatLocale {
    display: string;
	name: string;
	code: string;
	botFrameworkLocale: string;	
}